import { render, staticRenderFns } from "./step04.vue?vue&type=template&id=233a1e64&scoped=true"
import script from "./step04.vue?vue&type=script&lang=js"
export * from "./step04.vue?vue&type=script&lang=js"
import style0 from "./step04.vue?vue&type=style&index=0&id=233a1e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a1e64",
  null
  
)

export default component.exports